export const SHORTS_NORDIC_VIEWER = {
  VIDEO_JS_STYLE: 'https://http2.mlstatic.com/frontend-assets/shorts-nordic-viewer/videojs.4ff5eea5e00eaf6f87b4.css',
  VIDEO_JS_SCRIPT: 'https://http2.mlstatic.com/frontend-assets/shorts-nordic-viewer/videojs.a23f701605564af23722.js',
};
